/**
 * Панель видеоплеера на телефоне — показ по касанию (10.09.2026).
 *
 * ⚠️ ДО ЭТОГО ПАНЕЛЬ ЖИЛА ТОЛЬКО В CSS `group-hover`. На компьютере мышь над
 * кадром — панель видна. У пальца наведения нет, а касание кадра сразу ставило
 * ролик на паузу: перемотать играющий ролик на телефоне было нельзя, только
 * остановив его.
 *
 * Правило как в плеерах приложений: первое касание играющего ролика показывает
 * панель на несколько секунд и ролик не трогает; касание при видимой панели —
 * пауза. На компьютере всё как было: щелчок — пауза, панель — наведением.
 *
 * Логика вынесена из `YouTubePlayer.tsx`, потому что проверки собирают только
 * `*.test.ts` — правило внутри `.tsx` не проверялось бы вовсе.
 */

/** Сколько панель видна после касания. Хватает дотянуться до перемотки. */
export const PANEL_SHOW_MS = 3000;

export type FrameTapState = {
  /** Устройство без наведения — `(hover: none)`. */
  touch: boolean;
  playing: boolean;
  ended: boolean;
  /** Панель сейчас показана касанием. */
  panelShown: boolean;
};

/** Что делать с касанием по кадру. */
export function frameTap(s: FrameTapState): { togglePlay: boolean; showPanel: boolean } {
  if (!s.touch) return { togglePlay: true, showPanel: false };
  // Играет, панели не видно — только показать: ученик тянется к перемотке.
  if (s.playing && !s.ended && !s.panelShown) return { togglePlay: false, showPanel: true };
  return { togglePlay: true, showPanel: true };
}

/** Видна ли панель без наведения: на паузе, в конце и во время показа. */
export function panelVisible(s: { playing: boolean; ended: boolean; panelShown: boolean }): boolean {
  return !s.playing || s.ended || s.panelShown;
}
